import styled from "styled-components";

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 12px 20px;
  background: var(--filter-bar-bg);
  align-items: center;
  height: 84px;
  flex-wrap: wrap;
  row-gap: 10px;
  .label-wrapper {
    font-size: 16px;
    font-weight: 900;
    color: var(--theme-text);
    font-family: "Lato";
    font-style: normal;
  }
`;

export const Container = styled.div`
  padding: 22px 30px;
  background-color: #fafcff;
  max-height: calc(100vh - 60px);
  overflow: auto;
  .label {
    font-size: 13px;
    color: #1d1d1d;
    margin-bottom: 4px;
  }
  @media (max-width: 850px) {
    padding: 13px;
    max-height: none;  
    overflow: visible; 
    min-height: 100vh; 
  }
  .timeValidationMessage {
    font-size: 13px;
    color: red;
    margin-bottom: 20px;
  }
`;

export const Heading = styled.div`
  padding-right: 10px;
  display: flex;
  align-items: center;
  gap: 5px 14px;
  width: 100%;
  flex-wrap: wrap;
  h3 {
    font-weight: 700;
    font-size: 16px;
    line-height: 31px;
    color: #000000;
  }
  p {
    font-size: 14px;
    color: #000000b3;
  }
`;

export const BoxContainer = styled.div`
  margin-bottom: 24px;
`;

export const WorkSection = styled.div`
  background: #ffffff;
  position: relative;
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.05);
  padding: 30px 40px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(270px, 1fr));
  gap: 30px 7.708vw;
  &.fleet-general-tab {
    align-items: center;
    gap: 5px 7.708vw;
    .checkbox {
      margin-bottom: 13px;
    }
    .text-with-icon {
      font-size: 13px;
      line-height: 150.5%;
      display: flex;
      align-items: center;
      gap: 7px;
      margin-bottom: 10px;
    }
    .web-only {
      display: block;
    }
    .scorecard-email-input {
      padding: 0 10px;
    }
    label {
      font-size: 13px;
      color: #1d1d1d;
      /* margin-bottom: 4px; */
    }
    input {
      background: #ffffff;
      border: 1px solid #cdcfd0;
      border-radius: 6px;
      height: 30px;
      display: block;
      width: 100%;
      margin-bottom: 10px;
      :disabled {
        background: #eee;
      }
    }

    .select-wrapper {
      .select {
        margin-bottom: 10px;
        margin-top: 4px;
      }
      label {
        font-size: 13px;
        color: #1d1d1d;
      }
      .MuiFormControl-root {
        margin: 0;
        width: 100%;
      }
      .MuiSelect-select {
        background: #ffffff;
        border: 1px solid #cdcfd0;
        border-radius: 6px;
        font-size: 13px;
        padding: 2.5px 10px;
      }
    }
    @media (max-width: 850px) {
      padding: 15px;
      gap: 12px;
      grid-template-columns: 1fr;
      .web-only {
        display: none;
      }
    }
  }
  .web-only {
    display: block;
  }
  .scorecard-email-input {
    padding: 0 10px;
  }
  label {
    font-size: 13px;
    color: #1d1d1d;
    margin-bottom: 4px;
  }
  input {
    background: #ffffff;
    border: 1px solid #cdcfd0;
    border-radius: 6px;
    height: 30px;
    display: block;
    width: 100%;
    margin-bottom: 10px;
    :disabled {
      background: #eee;
    }
  }

  .select-wrapper {
    .select {
      margin-bottom: 10px;
      margin-top: 4px;
    }
    label {
      font-size: 13px;
      color: #1d1d1d;
    }
    .MuiFormControl-root {
      margin: 0;
      width: 100%;
    }
    .MuiSelect-select {
      background: #ffffff;
      border: 1px solid #cdcfd0;
      border-radius: 6px;
      font-size: 13px;
      padding: 2.5px 10px;
    }
  }
  @media (max-width: 850px) {
    padding: 15px;
    gap: 12px;
    grid-template-columns: 1fr;
    .web-only {
      display: none;
    }
  }
`;

export const CheckBoxWrapper = styled.div`
  position: relative;
  label {
    margin: 0;
  }
  .text-with-icon {
    font-size: 13px;
    line-height: 150.5%;
    display: flex;
    align-items: center;
    gap: 7px;
    margin-bottom: 10px;
  }
  &.no-side-border {
    ::after {
      display: none;
    }
  }

  .cloud-icon {
    position: absolute;
    top: 7px;
    right: 10px;
  }
  .checkbox {
    border: 1px solid #cdcfd0;
    border-radius: 6px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    min-width: 270px;
    min-height: 30px;
  }
  .MuiCheckbox-root {
    padding: 0;
    padding-right: 5px;
  }
  .MuiTypography-root {
    font-size: 13px;
    white-space: normal;
    padding-right: 30px;
  }
  label {
    font-size: 13px;
    color: #1d1d1d;
  }
`;

export const TextAreaBox = styled.div`
  position: relative;
  margin-bottom: 40px;
  textarea {
    width: 100%;
    background: #ffffff;
    border: 1px solid #cdcfd0;
    border-radius: 6px;
    padding: 10px;
    max-width: 100%;
    min-width: 100%;
  }
  label {
    font-size: 13px;
    color: #1d1d1d;
    margin-bottom: 4px;
  }
  span {
    position: absolute;
    color: #1d1d1d99;
    font-size: 11px;
    right: 0;
    bottom: -10px;
  }
  @media (max-width: 850px) {
    margin-bottom: 20px;
  }
`;

export const ActionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  button {
    font-size: 12px;
    line-height: 150.5%;
    color: #1d1d1d;
    padding: 5px 10px;
    border: 1px solid #636f7c;
    border-radius: 30px;
    display: flex;
    align-items: center;
    min-width: 72px;
    min-height: 31px;
    gap: 5px;
    background-color: #fff;
    font-family: "latobold";
    text-transform: inherit;
    justify-content: center;
    margin: 0;
    &.reset-btn {
      border: none;
      text-decoration: underline;
    }
    &.active {
      background: #bc9b6a;
      color: #fff;
      border-color: transparent;
    }
    &.disabled {
      pointer-events: none;
      cursor: default;
      color: rgba(0, 0, 0, 0.26);
    }
  }
  @media (max-width: 850px) {
    margin: 0 0 10px 0;
  }
`;

export const TimeOut = styled.div`
  padding: 13px 0;

  p {
    font-size: 13px;
    color: #1d1d1d;
    min-width: 96px;
    display: inline-flex;
  }
  input {
    background: #ffffff;
    border: 1px solid #cdcfd0;
    border-radius: 6px;
    max-width: 46px;
    height: 30px;
    margin: 0 6px 0 24px;
    padding: 5px 7px;
    display: inline-flex;
  }
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    opacity: 1;
  }
  span {
    color: #6c6c6c;
    font-size: 12px;
  }
  @media (max-width: 850px) {
    margin: 0 0 13px 0;
    padding: 0;
  }
`;

export const StartEndDate = styled.div`
  position: relative;
  width: max-content;
  .label {
    font-size: 13px;
    color: #1d1d1d;
    margin-bottom: 4px;
  }
  .MuiInputLabel-root {
    display: none;
  }
  fieldset {
    display: none;
  }
  input {
    max-height: 30px;
    padding: 0 10px;
    margin: 0;
    font-size: 13px;
    max-width: 120px;
  }
  .time-icon {
    position: absolute;
    right: 9px;
    bottom: 8px;
  }
`;

export const DateWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 11px;
  margin-bottom: 22px;
`;

export const UnlockModeWrapper = styled.div`
  margin-bottom: 22px;
`;

export const UnlockMode = styled.div`
  border: 1px solid var(--theme-background);
  border-radius: 6px;
  display: flex;
  align-items: center;
  width: max-content;
  button {
    height: 30px;
    color: #1d1d1dcc;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    min-width: 64px;
    padding: 0 11px;
    font-family: "latoregular";
    &.active {
      background: var(--theme-background);
      border-radius: 6px;
      font-weight: 700;
      color: var(--theme-text);
    }
  }
`;

export const LiabilityWaiver = styled.div`
  .flex-parent {
    display: flex;
    justify-content: space-between;
    padding: 10px;
  }
  .label {
    font-size: 13px;
    color: #1d1d1d;
    margin-bottom: 4px;
  }
  .child {
    padding: 10px;
    height: 100%
  }
  .child-two {
    padding: 10px;
    margin-bottom: 20px;
    max-width: 700px;
  }
  .preview {
    margin-bottom: 20px;
  }
  .quill-editor {
    height: 300px; 
  }
  .waiver-input {
    height: 100%;
    margin-bottom: 0px;
  }
`;

export const WaiverUploadBtnWrapper = styled.div`
  background: var(--input-background);
  border: 1px solid #cdcfd0;
  border-radius: 6px;
  display: flex;
  min-height: 22px;
  min-width: 80%;
  input[type="file"]::file-selector-button {
    margin-right: 20px;
    border: none;
    background: #bc9b6a;
    border-radius: 6px;
    padding: 10px 20px;
    color: #fff;
    cursor: pointer;
    transition: background 0.2s ease-in-out;
  }
  input {
    width: 100%;
  }
`;
